export default {
  data () {
    return {
      loginSuccess: false,
      closeHide: false,
      userInfoData: {},
      domain: '',
      nickname: '',
      thContent: '',
      alertShow: false,
      thTitle: '',
      apiUrls: {
        userinfo: '/api/userinfo',
        history: '/api/history',
        purchase: '/api/purchase',
        roll: '/api/roll',
        rewards: '/api/redeem',
        policy: '/api/policy_check'
      },
      pool: [],
      shareContent: '',
      pageStatus: 'main',
      exampleOpen: false,
      examplePage: '/static/images/example-1.jpg',
      userGems: 0,
      userId: '',
      title: 'T_EVENTNAME',
      overflow: false,
      msgType: '',
      fastNoticeMsg: '',
      pageLangJson: {},
      errorLangJson: {},
      notEnoughGems: 'TOAST_GEM_NOT_ENOUGH',
      networkError: 'TOAST_NETWORK_ERROR',
      eventsContent: 'T_P_RULE_DESC',
      confirm: 'COMMON_CONFIRM',
      cancel: 'COMMON_CANCEL',
      historyTitle: 'COMMON_HISTORY_DRAW',
      historyAllData: {},
      historyPool: 'man',
      historyData: [],
      confirmNoticeMsg: '',
      confirmItemName: '',
      confirmItemNum: 0,
      confirmItemId: 0,
      confirmPic: '',
      rewards: [],
      config: {
        region: 'en',
        lang: 'en',
        rule: ''
      },
      costPrice: 0,
      getPrizeContent: '',
      getPrizeItemName: '',
      getPrizeNum: '',
      serverStatus: false,
      transify: {
        T_P_CANCEL: 'Cancel',
        T_P_CONFIRM: 'Confirm',
        T_P_ERR_ACT_CLOSE: 'Event ended',
        T_P_ERR_ACT_NO_OPEN: 'Event start time: :name',
        T_P_ERR_DIAMOND_NONENOUGH: 'You do not have enough diamonds',
        T_P_ERR_LOGIN: 'Log in error, please try again later',
        T_P_GOP_LOGIN_ERROR: 'Request user information error',
        T_P_NOT_EVENT_PERIOD: 'not event period',
        T_P_RULE_TITLE: 'Event details',
        T_P_WRONG_REGION: 'wrong region',
        COMMON_BACK: 'back',
        COMMON_CANCEL: 'cancel',
        COMMON_CONFIRM: 'confirm',
        COMMON_CONTINUE_PURCHASE: 'continue to buy',
        COMMON_HISTORY_DRAW: '',
        COMMON_HISTORY_PURCHASE: '',
        COMMON_HISTORY_REDEEM: '',
        COMMON_NO: 'no',
        COMMON_PURCHASE: 'purchase',
        COMMON_PURCHASED: '',
        COMMON_QUANTITY_MAX: 'max',
        COMMON_TIPS_ITEM: 'the rewards will be sent directly to your vault',
        COMMON_YES: 'Yes',
        POPUP_TITLE_REDEEM: 'Congratulation! You got',
        POPUP_TITLE_UNIQUE: 'The unique items you owe',
        UNIQUE_BUY_ALREADY_HAVE:
          'You already own this item, if you purchase it again, it will be converted to FF tokens.',
        UNIQUE_BUY_ALREADY_HAVE_PART:
          'You already owe some of the item(s) you selected. If you purchase again, you will receive FF tokens instead.',
        UNIQUE_REDEEM_ALREADY_HAVE:
          'You already own this item, if you receive it again, it will be converted to FF tokens.',
        TOAST_ERROR_CODE: 'unknown error, error code {code}',
        TOAST_EVENT_CLOSED_AWHILE: 'The event is closed temporary',
        TOAST_EVENT_END: 'Event ended',
        TOAST_EVENT_NOTOPEN: "event hasn't started",
        TOAST_GEM_NOT_ENOUGH:
          'insufficient diamonds, please top up and come back again',
        TOAST_LOGIN_FAILED: 'login failed',
        TOAST_NETWORK_BUSY: 'Server busy, please try again later',
        TOAST_NETWORK_ERROR: 'Network connection error, please try again later',
        TOAST_OPERATE_BUSY: 'Too many requests, please try again later',
        TOAST_PAY_FAILED: 'purchase failed',
        TOAST_SERVER_BUSY: '',
        TOAST_SERVER_NOTWORK: 'service unavailable',
        TOAST_SERVER_TIMEOUT: 'service timeout',
        TOAST_WRONG_REGION: 'This event is not available for your region'
      },
      showStop: true,
      clickedStop: false,
      pageType: 'man',
      gemsPaid: 0,
      gemsNeeded: 100,
      itemScrollTop: 0,
      items: [],
      rewardPics: {
        item1: {
          1: 0,
          4: 0,
          pk: 0,
          status: 'notEnough'
        },
        item2: {
          2: 0,
          4: 0,
          pk: 0,
          status: 'notEnough'
        },
        item3: {
          3: 0,
          4: 0,
          pk: 0,
          status: 'notEnough'
        }
      },
      hasPics: {
        '1': 0,
        '2': 0,
        '3': 0,
        '4': 0
      },
      buyDialogItem: {},
      shareBtnShow: true,
      runLoading: true,
      analyticsId: 'UA-136757559-34',
      oneSpinPrice: 20,
      fiveSpinPrice: 100,
      drawingIntval: 0,
      drawedItemPK: [],
      rollRewards: [],
      spinModel: '',
      spinRewards: [],
      events: 1,
      got: [],
      skip: false,
      showUnique: false
    }
  },
  mounted () {
    this.initUserInfo()
  },
  methods: {
    openLoading () {
      this.overflow = true
      this.runLoading = true
      this.closeHide = true
    },
    closeLoading () {
      this.overflow = false
      this.runLoading = false
      this.closeHide = false
    },
    initGA (config) {
      document.body.setAttribute('data-lang', config['lang'])
      window.gtag('config', this.analyticsId, {
        dimension1: config.region_lang,
        page_title: 'Incubator 2.0',
        page_path: '/index.html'
      })
    },
    addGA (event, status) {
      var report = { event_label: status }
      window.gtag('event', event, report)
    },
    errorGA (err) {
      window.gtag('event', 'exception', {
        description: err,
        fatal: false
      })
    },
    getCookie (name) {
      var cookieValue = null
      if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';')
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i].trim()
          // Does this cookie string begin with the name we want?
          if (cookie.substring(0, name.length + 1) === name + '=') {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
            break
          }
        }
      }
      return cookieValue
    },
    initError (response) {
      this.closeLoading()
      this.msgType = 'fastNotice'
      this.closeHide = true
      this.confirmNoticeMsg = response.msg
      if (this.transify[response.msg]) {
        this.confirmNoticeMsg = this.transify[response.msg]
      }
      var keyName, i
      for (i in this) {
        if (typeof this[i] === 'string') {
          keyName = this[i]
          if (this.transify[keyName]) {
            this[i] = this.transify[keyName]
          }
        }
      }
      if (response.msg === 'T_P_ERR_ACT_NO_OPEN') {
        if (response.data.common_config) {
          var startDate = new Date(
            response.data.common_config.start_time * 1000
          )
          var endDate = new Date(response.data.common_config.end_time * 1000)
          var eventTime =
            startDate.toLocaleString() + ' -- ' + endDate.toLocaleString()
          this.confirmNoticeMsg = this.confirmNoticeMsg.replace(
            ':name',
            eventTime
          )
        }
      }
      this.overflow = true
    },
    checkReject (action) {
      var headers = {
        xhr: {
          withCredentials: true
        },
        headers: {
          'X-CSRFToken': this.getCookie('csrftoken')
        }
      }
      var policyUrl = this.domain + this.apiUrls.policy
      this.$http.post(policyUrl, action, headers).then(() => {
        this.alertShow = false
        this.addGA('policyReject', true)
      })
    },
    checkConfirm (action) {
      var headers = {
        xhr: {
          withCredentials: true
        },
        headers: {
          'X-CSRFToken': this.getCookie('csrftoken')
        }
      }
      var policyUrl = this.domain + this.apiUrls.policy
      this.$http.post(policyUrl, action, headers).then(() => {
        this.alertShow = false
        this.addGA('policyReject', false)
      })
    },
    /**
     * 初始化用户信息
     * */
    initUserInfo () {
      this.openLoading()
      if (!this.$route.query.access_token) {
        var _this = this
        this.pageStatus = 'other'
        setTimeout(function () {
          window.gtag('config', _this.analyticsId, {
            page_title: 'Incubator 2.0',
            page_path: '/index.html'
          })
          _this.initError('NO_ACCESS_TOKEN')
          _this.initNetworkError()
          _this.errorGA('NO_ACCESS_TOKEN')
        }, 100)
        return
      }
      var userInfoUrl =
        this.domain +
        // 'http://119.28.12.109:3100/mock/65' +
        this.apiUrls.userinfo +
        '?access_token=' +
        this.$route.query.access_token
      if (this.$route.query.lang) {
        userInfoUrl += '&lang=' + this.$route.query.lang
      }
      if (this.$route.query.region) {
        userInfoUrl += '&region=' + this.$route.query.region
      }
      var postData = {
        access_token: this.$route.query.access_token
      }
      if (this.$route.query.lang) {
        postData['lang'] = this.$route.query.lang
      }
      var headers = {
        xhr: {
          withCredentials: true
        }
      }
      this.$http.get(userInfoUrl, postData, headers).then(
        function (res) {
          if (res.body.status === 'error') {
            this.initError(res.body)
            return
          }
          this.loginSuccess = true
          this.serverStatus = true
          this.closeLoading()
          if (res.body.data['policy_popup']) {
            const {
              popup_title: policyTitle,
              popup_content: policyCtx,
              checked: policyHide
            } = res.body.data['policy_popup']
            this.alertShow = !policyHide
            this.thTitle = policyTitle
            this.thContent = policyCtx
          }
          this.initConfig(res.body.data.event_config)
          this.initGA(res.body.data.common_config)
          this.initTrans(res.body.data.transify)
          this.initPlayer(res.body.data.player, res.body.data.player_event)
          // this.deleteUrlParam('access_token')
        },
        function (e) {
          console.log(e)
          this.pageStatus = 'other'
          if (e.body.msg) {
            this.initError(e.body)
          } else {
            this.initNetworkError()
          }
          this.errorGA(e)
        }
      )
    },
    deleteUrlParam (name) {
      var query = window.location.search.substr(1)
      if (query.indexOf(name) > -1) {
        var obj = {}
        var arr = query.split('&')
        for (var i = 0; i < arr.length; i++) {
          arr[i] = arr[i].split('=')
          obj[arr[i][0]] = arr[i][1]
        }
        delete obj[name]
        var url = JSON.stringify(obj)
          .replace(/[\"\{\}]/g, '')
          .replace(/\:/g, '=')
          .replace(/\,/g, '&')
        var http =
          document.location.protocol == 'https:' ? 'https://' : 'http://'
        window.history.replaceState(
          {},
          0,
          http + window.location.host + window.location.pathname + '?' + url
        )
      }
    },
    initNetworkError () {
      this.closeLoading()
      this.serverStatus = false
      this.msgType = 'fastNotice'
      this.confirmNoticeMsg = this.transify['TOAST_NETWORK_ERROR']
      this.overflow = true
      this.closeHide = true
      this.addGA('msgError', 'TOAST_NETWORK_ERROR')
    },
    initConfig (obj) {
      this.config = obj
      this.oneSpinPrice = obj.oncespin
      this.fiveSpinPrice = obj.fivespin

      for (let i in obj.pool) {
        if (!obj.pool[i]['num']) {
          obj.pool[i]['num'] = 1
        }
      }
      // console.log(obj.pool)
      this.pool = obj.pool.sort((a, b) => {
        if (a.pos > b.pos) {
          return 1
        }
        if (a.pos < b.pos) {
          return -1
        }
        return 0
      })
      // console.log(obj.pool)
      // let rewards = obj.rewards.sort(function (a, b) {
      //   return a.pos > b.pos
      // })
      let rewards = obj.rewards.sort((a, b) => {
        if (a.pos > b.pos) {
          return 1
        }
        if (a.pos < b.pos) {
          return -1
        }
        return 0
      })
      let item = rewards[0]
      this.rewardPics.item1['1'] = item['required']['1']
      this.rewardPics.item1['4'] = item['required']['4']
      this.rewardPics.item1['pk'] = item['pk']
      this.rewardPics.item1['name'] = item['name']
      item = rewards[1]
      this.rewardPics.item2['2'] = item['required']['2']
      this.rewardPics.item2['4'] = item['required']['4']
      this.rewardPics.item2['pk'] = item['pk']
      this.rewardPics.item2['name'] = item['name']
      item = rewards[2]
      this.rewardPics.item3['3'] = item['required']['3']
      this.rewardPics.item3['4'] = item['required']['4']
      this.rewardPics.item3['pk'] = item['pk']
      this.rewardPics.item3['name'] = item['name']
    },
    initPlayer (player, event) {
      this.userInfoData = event
      this.userId = player.uid
      this.userGems = player.gems
      window.gtag('set', { user_id: player.uid })
      this.addGA('login', 'success')
      this.hasPics = event.fragment
      this.got = event.got
      this.resetRewardsStatus()
    },
    showConfirmMsg (msg) {
      this.confirmNoticeMsg = msg
      this.overflow = true
      this.msgType = 'confirm'
    },
    showConfirmCancelMsg (msg) {
      var itemInfo = this.getItem(msg.itemId)
      this.isEp = itemInfo['isEp']
      this.confirmItemName = itemInfo.name

      if (itemInfo.isBigPrize) {
        this.confirmItemNum = 1
        this.costPrice = this.countPrice(itemInfo.price)
      } else {
        this.confirmItemNum = msg.num
        this.costPrice =
          parseInt(((100 - this.percentNum) * itemInfo.price) / 100) * msg.num
      }
      if (!this.checkGem()) {
        return
      }
      this.confirmItemId = msg.itemId

      this.overflow = true
      if (itemInfo['isEp'] && this.userInfoData.ep_owned) {
        this.confirmNoticeMsg = this.transify['T_P_EPCARD_HINT']
      } else {
        this.confirmNoticeMsg = this.transify[
          'TXT_WEBEVENT_GXQ_MSHOP_PURCHASE_DOUBLE_CHECK'
        ]
      }

      this.msgType = 'confirmWithCancel'
    },
    showHistory () {
      this.overflow = true
      this.msgType = 'historyNotice'
      this.historyPool = this.pageType
      if (this.serverStatus === false) {
        return
      }
      this.serverStatus = false
      var historyUrl = this.domain + this.apiUrls.history
      var headers = {
        xhr: {
          withCredentials: true
        },
        headers: {
          'X-CSRFToken': this.getCookie('csrftoken')
        }
      }
      this.$http.post(historyUrl, {}, headers).then(
        function (res) {
          this.serverStatus = true
          if (res.body.status === 'error') {
            this.msgError(res.body)
            return
          }
          this.historyData = []
          var tmpData = res.body.data.history
          for (var i in tmpData) {
            var tmp = {
              created_at: tmpData[i].created,
              price: tmpData[i].price,
              items: []
            }
            if (tmpData[i].pk) {
              var pk = tmpData[i].pk
              for (var ii in pk) {
                var tmpItem
                if (tmp.price > 0) {
                  tmpItem = this.getItem(pk[ii])
                  if (!tmpItem) {
                    continue
                  }
                  tmpItem['hideName'] = true
                  tmpItem.image = tmpItem.img
                  tmp.items.push(tmpItem)
                } else {
                  tmpItem = this.getRewardItem(pk[ii])
                  if (!tmpItem) {
                    tmpItem = this.getItem(pk[ii])
                  }
                  if (!tmpItem) {
                    continue
                  }
                  if (tmpItem.img) {
                    tmpItem['image'] = tmpItem.img
                  }
                  tmp.items.push({
                    hideName: true,
                    img: tmpItem['image'],
                    pk: pk[ii],
                    num: tmpItem['num']
                  })
                }
              }
            }
            this.historyData.push(tmp)
          }
        },
        function (e) {
          this.msgNetworkError()
        }
      )
    },
    drawHistory (type) {
      this.historyData = []
      for (var i in this.historyAllData[type]) {
        this.historyData.push(this.historyAllData[type][i])
      }
    },
    showPrizes (rewards) {
      this.overflow = true
      this.msgType = 'prizesNotice'
      this.serverStatus = true
      var items = this.$refs.items
      for (var i in items) {
        items[i].stopRolling()
        items[i].removeFocus()
      }
      items = []
      for (i in rewards) {
        let tmp = this.getItem(rewards[i])
        tmp.image = tmp.img
        tmp['setNum'] = tmp.num
        items.push(tmp)
        if (tmp.type > 0) {
          this.hasPics[tmp.type] += tmp.num
        }
      }
      this.addGA('confirm', 'prizes')
      this.rollRewards = items
      this.resetRewardsStatus()
      clearInterval(this.drawingIntval)
      this.clearAllHighLight()
    },
    resetRewardsStatus () {
      var item1 = this.getRewardInfo(1)
      var item2 = this.getRewardInfo(2)
      var item3 = this.getRewardInfo(3)
      if (this.got.indexOf(item1.pk) > -1) {
        this.rewardPics.item1.status = 'redeemed'
      } else if (
        this.hasPics['1'] >= item1.required['1'] &&
        this.hasPics['4'] >= item1.required['4']
      ) {
        this.rewardPics.item1.status = 'redeem'
      } else {
        this.rewardPics.item1.status = 'notEnough'
      }
      if (this.got.indexOf(item2.pk) > -1) {
        this.rewardPics.item2.status = 'redeemed'
      } else if (
        this.hasPics['2'] >= item2.required['2'] &&
        this.hasPics['4'] >= item2.required['4']
      ) {
        this.rewardPics.item2.status = 'redeem'
      } else {
        this.rewardPics.item2.status = 'notEnough'
      }
      if (this.got.indexOf(item3.pk) > -1) {
        this.rewardPics.item3.status = 'redeemed'
      } else if (
        this.hasPics['3'] >= item3.required['3'] &&
        this.hasPics['4'] >= item3.required['4']
      ) {
        this.rewardPics.item3.status = 'redeem'
      } else {
        this.rewardPics.item3.status = 'notEnough'
      }
    },
    checkGem () {
      if (this.userGems < this.costPrice) {
        this.msgType = 'fastNotice'
        this.confirmNoticeMsg = this.transify['TOAST_GEM_NOT_ENOUGH']
        this.overflow = true
        return false
      }
      return true
    },
    toggle () {
      this.exampleOpen = !this.exampleOpen
    },
    close () {
      this.overflow = false
      this.pageStatus = 'main'
    },
    msgOpen () {
      this.overflow = true
    },

    /**
     * 显示主页面
     */
    toMain () {
      this.pageStatus = 'main'
      this.printMain()
    },
    printMain () {},
    formatItemData (data) {},
    buyItem () {},
    countPrice (num) {
      return parseInt(((100 - this.percentNum) * num) / 100)
    },
    formatDate (num) {
      return new Date(num * 1000).toLocaleString()
    },
    openBuyItemDialog (itemId) {
      this.overflow = true
      this.msgType = 'buyDialog'
      this.buyDialogItem = this.getItem(itemId)
      this.$refs.countitem.resetNum()
    },
    getItem (itemId) {
      for (var i in this.pool) {
        if (this.pool[i]['pk'] === itemId) {
          return this.pool[i]
        }
      }
    },
    updateItemInfo (itemId, num) {
      for (var i in this.items) {
        if (this.items[i]['itemId'] === itemId) {
          var item = this.items[i]
          item['hasBuy'] += num
          this.$set(this.items[i], item)
          return
        }
      }
    },
    initTrans (trans) {
      this.transify = trans
    },
    showEvents () {
      this.overflow = true
      this.msgType = 'eventsNotice'
      this.addGA('display', 'faq')
    },
    showReadmore () {
      this.overflow = true
      this.msgType = 'readmore'
      this.addGA('display', 'readmore')
    },
    /***
     * 抽奖1次
     */
    oneSpin () {
      if (!this.serverStatus) {
        return
      }
      // this.overflow = true
      // this.msgType = 'spinConfirm'
      this.closeHide = false
      this.spinModel = 'one'
      this.startSpin()
      this.addGA('one', 'confirm')
    },
    /***
     * 抽奖5次
     */
    fiveSpin () {
      if (!this.serverStatus) {
        return
      }
      // this.overflow = true
      // this.msgType = 'spinConfirm'
      this.closeHide = false
      this.spinModel = 'five'
      this.startSpin()
      this.addGA('five', 'confirm')
    },
    /**
     * 开始抽奖
     * */
    startSpin () {
      if (!this.serverStatus) {
        return
      }
      this.serverStatus = false
      var data
      if (this.spinModel === 'one') {
        data = {
          price: this.oneSpinPrice,
          spin: 1
        }
      } else {
        data = {
          price: this.fiveSpinPrice,
          spin: 6
        }
      }
      this.costPrice =
        this.spinModel === 'five' ? this.fiveSpinPrice : this.oneSpinPrice
      if (!this.checkGem(data.price)) {
        this.serverStatus = true
        return
      }
      this.addGA(this.spinModel, 'start')
      this.drawing()
    },
    msgNetworkError () {
      this.serverStatus = true
      this.msgType = 'confirm'
      this.confirmNoticeMsg = this.transify['TOAST_NETWORK_ERROR']
      this.overflow = true
      this.closeHide = true
      setTimeout(function () {
        self.location.reload()
      }, 3000)
    },
    drawing () {
      this.overflow = false
      this.drawedItemPK = 0
      this.addGA('drawing', 'drawing')
      var items = this.$refs.items
      clearInterval(this.drawingIntval)
      for (var i in items) {
        items[i].startRolling()
        items[i].removeFocus()
      }
      var now = 0
      var length = items.length - 1
      var _this = this
      _this.events = 0
      var drawTime = 1100
      if (this.spinModel === 'five') {
        drawTime = 600
      }
      if (this.skip) {
        _this.draw()
      } else {
        // 延时触发ajax请求
        setTimeout(function () {
          _this.draw()
        }, drawTime)
      }

      // 开启抽奖动画
      this.drawingIntval = setInterval(function () {
        now = parseInt(now)
        // 移除高亮
        items[now].removeFocus()
        now = parseInt(now)
        if (now >= length) {
          now = -1
        }
        now = now + 1
        for (var i in items) {
          if (i < now) {
            continue
          }
          // 单个高亮
          var status = items[i].setFocus()
          if (status) {
            now = i
            if (items[i].getPK() === _this.drawedItemPK) {
              clearInterval(_this.drawingIntval)
              if (_this.spinModel === 'one') {
                /***
                 * 直接弹窗
                 */
                setTimeout(function () {
                  _this.showPrizes(_this.spinRewards)
                }, 1000)
              }
            }
            break
          }
          continue
        }
      }, 50)
    },
    /**
     * 奖励逐个高亮
     * 抽奖ajax 后调用
     * */
    highLight () {
      var _this = this
      if (this.skip) {
        _this.showPrizes(_this.spinRewards)
        return
      }
      if (_this.events > 4) {
        // 当没有剩余高亮的时候就开启弹窗
        setTimeout(function () {
          _this.showPrizes(_this.spinRewards)
        }, 500)
        return
      }
      // 停留500毫秒
      setTimeout(function () {
        // 初始化转圈设定
        _this.drawedItemPK = 0
        _this.clearAllHighLight()
        var now = 0
        var items = _this.$refs.items
        var length = items.length - 1
        // 启动转圈
        clearInterval(_this.drawingIntval)
        _this.drawingIntval = setInterval(function () {
          now = parseInt(now)
          items[now].removeFocus()
          now = parseInt(now)
          if (now >= length) {
            now = -1
          }
          now = now + 1
          for (var i in items) {
            if (i < now) {
              continue
            }
            var status = items[i].setFocus()
            if (status) {
              now = i
              if (items[i].getPK() === _this.drawedItemPK) {
                clearInterval(_this.drawingIntval)
                _this.highLight()
              }
              break
            }
            continue
          }
        }, 50)
      }, 500)
      setTimeout(function () {
        _this.drawedItemPK = _this.spinRewards[_this.events++]
      }, 1500)
    },
    /**
     * 单个高亮
     * */
    highLightItem (pk) {
      // 移除所有高亮
      var items = this.$refs.items
      for (var i in items) {
        items[i].startRolling()
        if (items[i].pk !== pk) {
          items[i].removeFocus()
        } else {
          items[i].setFocus()
        }
      }
    },
    /**
     * 清除所有高亮
     * */
    clearAllHighLight () {
      var items = this.$refs.items
      for (var i in items) {
        items[i].removeFocus()
      }
    },
    /**
     * 抽奖
     */
    draw () {
      this.addGA('draw', 'start')
      var rollUrl = this.domain + this.apiUrls.roll
      var headers = {
        xhr: {
          withCredentials: true
        },
        headers: {
          'X-CSRFToken': this.getCookie('csrftoken')
        }
      }
      this.costPrice =
        this.spinModel === 'five' ? this.fiveSpinPrice : this.oneSpinPrice
      this.$http
        .post(
          rollUrl,
          {
            price: this.costPrice,
            spin: this.spinModel === 'five' ? 5 : 1
          },
          headers
        )
        .then(
          function (res) {
            if (res.body.status === 'error') {
              this.msgError(res.body)
              var items = this.$refs.items
              clearInterval(this.drawingIntval)
              for (var i in items) {
                items[i].stopRolling()
                items[i].removeFocus()
              }
              this.serverStatus = true
              return
            }
            this.addGA('draw', 'success')
            this.userGems -= this.costPrice
            this.costPrice = 0
            this.spinRewards = res.body.data.rewards

            if (res.body.data.status === 0) {
              this.showUnique = true
              this.confirmNoticeMsg =
                res.body.data.rewards && res.body.data.rewards.length > 1
                  ? this.transify['UNIQUE_BUY_ALREADY_HAVE_PART']
                  : this.transify['UNIQUE_REDEEM_ALREADY_HAVE']
            } else {
              this.showUnique = true
              this.confirmNoticeMsg = this.transify['COMMON_TIPS_ITEM']
            }
            /**
             * 设定停止点
             * */
            if (this.spinModel === 'one') {
              this.drawedItemPK =
                res.body.data.rewards[res.body.data.rewards.length - 1]
            } else {
              this.highLight()
            }
          },
          function (e) {
            var items = this.$refs.items
            clearInterval(this.drawingIntval)
            for (var i in items) {
              items[i].stopRolling()
              items[i].removeFocus()
            }
            this.serverStatus = true
            this.msgNetworkError()
            this.errorGA(e)
          }
        )
    },
    msgError (response) {
      this.msgType = 'fastNotice'
      this.addGA('msgError', response.msg)
      this.confirmNoticeMsg = response.msg
      if (this.transify[response.msg]) {
        this.confirmNoticeMsg = this.transify[response.msg]
      } else {
        this.confirmNoticeMsg = this.transify['TOAST_NETWORK_ERROR']
      }
      var keyName, i
      for (i in this) {
        if (typeof this[i] === 'string') {
          keyName = this[i]
          if (this.transify[keyName]) {
            this[i] = this.transify[keyName]
          }
        }
      }
      this.overflow = true
    },
    toastError (msg) {
      this.msgType = 'fastNotice'
      this.addGA('toastError', msg)
      if (this.transify[msg]) {
        this.confirmNoticeMsg = this.transify[msg]
      } else {
        this.confirmNoticeMsg = this.transify['TOAST_NETWORK_ERROR']
      }
      this.overflow = true
    },
    getRewards (pk) {
      if (!this.serverStatus) {
        return
      }
      this.serverStatus = false
      var url = this.domain + this.apiUrls.rewards
      var headers = {
        xhr: {
          withCredentials: true
        },
        headers: {
          'X-CSRFToken': this.getCookie('csrftoken')
        }
      }
      var obj = this.getRewardInfo(pk)
      if (!obj.num) {
        obj.num = 1
      }
      this.addGA('reward' + obj.name, 'start')
      var data = { pk: obj.pk }
      this.$http.post(url, data, headers).then(
        function (res) {
          this.serverStatus = true
          if (res.body.status === 'error') {
            this.msgError(res.body)
            return
          }
          if (res.body.data.status === 0) {
            this.showUnique = true
            this.confirmNoticeMsg =
              res.body.data.rewards && res.body.data.rewards.length > 1
                ? this.transify['UNIQUE_BUY_ALREADY_HAVE_PART']
                : this.transify['UNIQUE_REDEEM_ALREADY_HAVE']
          } else {
            this.showUnique = true
            this.confirmNoticeMsg = this.transify['COMMON_TIPS_ITEM']
          }
          this.got.push(obj.pk)
          this.setGot()
          this.overflow = true
          this.msgType = 'prizesNotice'
          this.addGA('reward' + obj.name, 'success')
          let tmp = {
            img: obj.img,
            name: obj.name,
            num: obj.num
          }
          this.rollRewards = [tmp]
          for (var name in obj.required) {
            this.hasPics[name] -= obj.required[name]
          }
          this.resetRewardsStatus()
        },
        function (e) {
          this.msgNetworkError()
        }
      )
    },
    setGot () {},
    getRewardInfo (pos) {
      for (var i in this.config.rewards) {
        if (this.config.rewards[i].pos === pos) {
          return this.config.rewards[i]
        }
      }
      return null
    },
    getRewardItem (pk) {
      for (var i in this.config.rewards) {
        if (this.config.rewards[i]['pk'] === pk) {
          return this.config.rewards[i]
        }
      }
    },
    toggleSkip () {
      this.skip = !this.skip
    }
  },
  computed: {
    reverseHistory () {
      var nowHistory = this.historyData
      return nowHistory.reverse()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/home.vue.js